import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { CreateReceiptDto, ReceiptBaseDto } from '../types';

export const useCreateReceipt = () => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<ReceiptBaseDto, Error, CreateReceiptDto>({
    mutationFn: (data) => apiClient.post(`/v1/projects/${projectId}/receipts`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['receipts', projectId] });
    },
  });
};
